export default __webpack_public_path__ + "static/media/busy_station_icon.b22b945f.png";